import { URL_ME, API_WALLET_URL } from 'config'
import { apiCall } from './base'

export const getConcepts = () =>
  apiCall(`${URL_ME}/api/v1/me/cashout/concepts`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => res.data)

export const getCashoutLimit = () =>
  apiCall(`${URL_ME}/api/v1/me/cashout/limit`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })

export const setCashout = (data) =>
  apiCall(`${URL_ME}/api/v1/me/cashout/`, {
    baseURL: API_WALLET_URL,
    method: 'POST',
    withCredentials: false,
    immediately: true,
    data
  })

export const getCashoutDestination = ({ type, value }) =>
  apiCall(
    `${URL_ME}/api/v1/me/cashout/destination-information/${type}/${value}`,
    {
      baseURL: API_WALLET_URL,
      method: 'GET',
      withCredentials: false,
      immediately: true
    }
  )

export const getRecentCashouts = () =>
  apiCall(`${URL_ME}/api/v1/me/cashout/recents`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })
